<template>
    <div class="qingwu">
        <el-form  label-width="100px" ref="info" :model="info">
          <el-form-item label-width="150px" label="是否开启第三方配送" prop="peisxz"><el-switch v-model="info.peisxz" :active-text="info.peisxz?'开启':'关闭'"></el-switch></el-form-item>
            <el-form-item label-width="160px" label="备注："><el-tag type="info">是否开启第三方配送</el-tag></el-form-item>
            <el-form-item label-width="160px">
                <el-button type="primary" @click="submitForm('info')">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          info:{
            peisxz:''
          },
          upload_headers:{},
          logo:''
      };
    },
    watch: {},
    computed: {},
    methods: {
        handleAvatarSuccess(res) {
            this.info.logo = res.data;
            this.$forceUpdate();
        },
        submitForm:function(e){
            this.$refs[e].validate(res=>{
                if(res){
                    // Http 请求
                    this.info.peisxz = this.info.peisxz?1:0;
                    this.$post(this.$api.peisxzConfig,this.info).then(postRes=>{
                        if(postRes.code == 200){
                            this.$message.success("编辑成功");
                            this.get_alipaypc_config();
                        }else{
                            this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_alipaypc_config(){
            this.$get(this.$api.peisxzConfig).then(res=>{
                if(res.data != null){
                    this.info  = res.data;
                    this.info.peisxz = this.info.peisxz==1?true:false;
                }
            });
        },
    },
    created() {
        this.get_alipaypc_config();
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>